export default __webpack_public_path__ + "images/nvent-brand-caddy.png?0f6a52df16f6864d1b7d5033f9e809cc";